export default {
  translation: {
    // Navigation
    'nav.about': 'Über die ABC Listen-Methode',
    'nav.privacy': 'Datenschutz',
    'nav.imprint': 'Impressum',

    // Homepage
    'home.title': 'Kreatives Brainstorming mit der ABC-Methode',
    'home.subtitle': 'Lass dich vom Alphabet inspirieren und entwickle neue Ideen',
    'home.topic.label': 'Welches Thema möchtest du brainstormen?',
    'home.topic.placeholder': 'z.B. Ideen für mein Startup',
    'home.nickname.label': 'Dein Nickname',
    'home.nickname.placeholder': 'Wie sollen dich andere Teilnehmer sehen?',
    'home.start.button': 'Starte dein Brainstorming',

    // Homepage new sections
    'home.explanation.title': 'Die ABC-Methode kurz erklärt',
    'home.explanation.intro': 'Die ABC-Methode nutzt die Kraft des Alphabets, um deine Kreativität zu entfesseln und neue Ideen zu entwickeln. So funktioniert es:',
    'home.explanation.step1': 'Wähle dein Thema, zu dem du Ideen sammeln möchtest',
    'home.explanation.step2': 'Nutze die Buchstaben des Alphabets als Impulsgeber für deine Assoziationen',
    'home.explanation.step3': 'Entdecke neue Verbindungen zwischen deinen Ideen',
    'home.explanation.learn_more': 'Mehr über die Methode erfahren',
    
    'home.form.title': 'Deine Brainstorming-Session starten',
    
    'home.features.title': 'Warum ABCbrain?',
    'home.features.method.title': 'Bewährte Methode',
    'home.features.method.description': 'Die ABC-Methode nach Vera F. Birkenbihl ist eine nachweislich effektive Technik, um Denkblockaden zu überwinden und neue Perspektiven zu finden.',
    'home.features.ai.title': 'KI-Analyse',
    'home.features.ai.description': 'Lass deine Ideen von künstlicher Intelligenz analysieren und erhalte überraschende Einsichten und Verbindungen.',
    'home.features.collaborate.title': 'Zusammenarbeit',
    'home.features.collaborate.description': 'Brainstorme mit bis zu 5 Personen gleichzeitig in Echtzeit und nutzt gemeinsam eure kreative Energie.',

    // Session
    'session.participants': 'Teilnehmer',
    'session.participants.count': 'Brainstorming-Session mit',
    'session.participants.limit': 'von',
    'session.session_of': 'Brainstorming-Session von',
    'session.progress': 'Fortschritt',
    'session.letters': 'Buchstaben',
    'session.words': 'Wörter',
    'session.invite': 'Link kopieren und einladen',
    'session.finish': 'Brainstorming beenden',
    'session.resume': 'Brainstorming fortsetzen',
    'session.finished': 'Brainstorming wurde beendet',
    'session.finished_message': 'Diese Brainstorming-Session ist abgeschlossen. Du kannst die Ergebnisse anschauen oder eine neue Session starten.',
    'session.start_new_session': 'Neue Session starten',
    'session.readonly': 'Schreibgeschützter Modus',
    'session.invalid': 'Session nicht gefunden',
    'session.expired': 'Diese Session ist abgelaufen',
    'session.join.title': 'Session beitreten',
    'session.join.button': 'Session beitreten',

    // Session Timer
    'session.timer.expired': 'Abgelaufen',
    'session.timer.days': 'Noch {{count}} Tag(e)',
    'session.timer.hours': 'Noch {{count}} Stunde(n)',
    'session.timer.minutes': 'Noch {{count}} Minute(n)',
    'session.timer.info.aria': 'Mehr Informationen zur Ablaufzeit',
    'session.timer.info.tooltip': 'Diese Session läuft automatisch nach 30 Tagen ab',

    'session.tip.difficult_letters': 'Tipp: Versuche auch schwierige Buchstaben wie Q, X oder Y.',
    'session.start_own': 'Eigene Session starten',
    'session.start_own.description': 'Starte deine eigene Brainstorming-Session und sammle kreative Ideen mit der ABC-Methode.',
    'session.start_new': 'Neue Session starten',
    'session.invite.copied': 'Link kopiert!',

    // Analysis
    'analysis.title': 'KI-Analyse deiner Ideen',
    'analysis.request': 'Ideen jetzt analysieren',
    'analysis.request_new': 'Neue Analyse anfordern',
    'analysis.loading': 'Analysiere deine Ideen...',
    'analysis.error': 'Es gab einen Fehler bei der Analyse',
    'analysis.retry': 'Schließen und erneut versuchen',
    'analysis.available': 'Eine KI-Analyse deiner Ideen ist verfügbar.',
    'analysis.description': 'Erhalte eine detaillierte KI-Analyse deiner Brainstorming-Session mit den wichtigsten Erkenntnissen.',
    'analysis.show': 'Analyse anzeigen',
    'analysis.entries_needed': 'Noch {{count}} Einträge bis zur Analyse',
    'analysis.price': '(1 CHF)',
    'analysis.price_info': '1 CHF (Einmalzahlung)',
    'analysis.beta_free': 'Kostenlos während der Beta-Phase',

    // ABC Method Page
    'abc.title': 'Die ABC-Methode',
    'abc.subtitle': 'Kreatives Brainstorming nach Vera F. Birkenbihl – einfach erklärt und sofort anwendbar',
    'abc.intro': 'Die ABC-Methode auf ABCbrain.xyz verwandelt deine Brainstorming-Sessions in ein kreatives Abenteuer. Entwickelt von Vera F. Birkenbihl, nutzt diese Methode die Kraft der assoziativen Kognition – der natürlichen Fähigkeit unseres Gehirns, Informationen spielerisch zu verknüpfen – und macht sie zu deinem persönlichen Werkzeugkasten für frische, unkonventionelle Ideen.',
    'abc.start.button': 'Jetzt kostenlos starten',
    
    'abc.how_it_works.title': 'So funktioniert die ABC-Methode',
    'abc.how_it_works.step1.title': 'Schritt 1 – Wähle dein Thema',
    'abc.how_it_works.step1.description': 'Beginne mit einem konkreten Thema, einer Frage oder einer Herausforderung, für die du neue Perspektiven suchst. Beispiel: „Neue Geschäftsideen".',
    'abc.how_it_works.step2.title': 'Schritt 2 – Spontan Assoziieren',
    'abc.how_it_works.step2.description': 'Schreibe spontan und ohne Nachdenken Wörter auf, die dir zu jedem Buchstaben des Alphabets einfallen. Die automatisch scrollenden Buchstaben von ABCbrain.xyz geben dir visuelle Denkanstöße, doch du bist vollkommen frei darin, jederzeit eigene Buchstaben und Begriffe zu wählen.',
    'abc.how_it_works.step2.example.title': 'Beispiel:',
    'abc.how_it_works.step2.example.a': 'Apfelautomat',
    'abc.how_it_works.step2.example.b': 'Bahnhof-Café',
    'abc.how_it_works.step2.example.c': 'Coworking-Space',
    'abc.how_it_works.step2.example.d': 'Drohnenlieferdienst',
    'abc.how_it_works.step3.title': 'Schritt 3 – Neue Verbindungen entdecken',
    'abc.how_it_works.step3.description': 'Durch das Sammeln von scheinbar unzusammenhängenden Ideen entstehen überraschende und innovative Verknüpfungen. Vielleicht entsteht aus der Kombination von „Apfelautomat" und „Bahnhof-Café" ein mobiles, gesundes Snack-Angebot für Pendler.',
    
    'abc.why_effective.title': 'Warum ist die Methode so effektiv?',
    'abc.why_effective.description': 'Unser Gehirn liebt es, frei zu assoziieren – dadurch entstehen neue Verbindungen zwischen Konzepten, die wir normalerweise getrennt wahrnehmen. Dieses Phänomen, die sogenannte assoziative Kognition, wird aktiv genutzt, um Denkblockaden zu überwinden und kreativen Flow zu fördern.',
    
    'abc.ai_support.title': 'KI-Unterstützung für noch mehr Ideen',
    'abc.ai_support.description': 'Nachdem du deine ABC-Liste erstellt hast, analysiert die integrierte KI automatisch deine Ergebnisse und erstellt ein übersichtliches Clustering. Dadurch erkennst du überraschende Muster, neue Zusammenhänge und erhältst weitere inspirierende Impulse.',
    
    'abc.ready.title': 'Bereit, kreativ zu werden?',
    'abc.ready.description': 'Ganz gleich, ob beruflich, privat oder für dein nächstes Herzensprojekt: Die ABC-Methode bringt frische Luft in deine Denkprozesse und inspiriert dich zu außergewöhnlichen Ideen. Teste es jetzt kostenlos und entdecke, wohin deine Kreativität dich führen kann!',
    
    'abc.cta.title': 'Starte dein kreatives Abenteuer!',

    // Common
    'common.loading': 'Lade...',
    'common.error': 'Ein Fehler ist aufgetreten',
    'common.retry': 'Erneut versuchen',
    'common.close': 'Schließen',
    'common.back': 'Zurück',
    'common.next': 'Weiter',
    'common.save': 'Speichern',
    'common.cancel': 'Abbrechen',
    'common.delete': 'Löschen',
    'common.edit': 'Bearbeiten',
    'common.home': 'Zurück zur Startseite',

    // Error pages
    'error.404.title': '404 - Seite nicht gefunden',
    'error.404.message': 'Der Link könnte abgelaufen sein oder die Session wurde beendet.',

    // Connection Error
    'error.connection.title': 'Verbindungsfehler',
    'error.connection.message': 'Es konnte keine Verbindung zum Server hergestellt werden. Bitte überprüfe deine Internetverbindung und versuche es erneut.',
    'error.connection.connecting': 'Verbinde...',
    'error.connection.retry': 'Erneut versuchen',

    // Privacy Page
    'privacy.title': 'Datenschutzerklärung',
    'privacy.subtitle': 'Weil Datenschutz wichtig ist – und weil ich\'s muss.',
    'privacy.intro': 'Hallo! Ich bin Patrick, dein Gastgeber auf ABCbrain.xyz. Ich liebe kreative Ideen – aber keine unnötigen Daten. Trotzdem muss ich hier ein paar Dinge klären.',
    
    'privacy.data.title': 'Welche Daten werden gesammelt?',
    'privacy.data.subtitle': 'Kurz gesagt: So wenig wie möglich, aber ein bisschen was geht halt doch.',
    'privacy.data.visit.title': 'Wenn du die Website besuchst:',
    'privacy.data.visit.text': 'Netlify freut sich über ein paar technische Daten (IP-Adresse, Browsertyp, usw.), damit alles flüssig läuft.',
    'privacy.data.brainstorm.title': 'Wenn du brainstormst:',
    'privacy.data.brainstorm.text': 'Deine geniale Wortkreation wird sicher in einer Supabase-Datenbank gespeichert, damit du später darauf zurückgreifen kannst.',
    'privacy.data.payment.title': 'Wenn du bezahlst:',
    'privacy.data.payment.text': 'Das übernimmt Stripe – ich sehe nicht mal, ob du mit Karte, Apfel, Banane oder Krypto bezahlst. Stripe regelt das mit deren eigenen Sicherheitsmassnahmen.',
    'privacy.data.message.title': 'Wenn du mir eine Nachricht schreibst:',
    'privacy.data.message.text': 'Die landet bei mir in der Inbox, aber ich verspreche, sie nicht an Aliens weiterzugeben. 👽',
    
    'privacy.ai.title': 'Was macht OpenAI mit deinen Ideen?',
    'privacy.ai.text': 'Die KI-Zusammenfassung läuft über OpenAI, aber keine Sorge – deine Eingaben werden nicht gespeichert (zumindest nicht von mir). Falls OpenAI sich Notizen macht, liegt das ausserhalb meiner Kontrolle.',
    
    'privacy.not.title': 'Was ich NICHT mache',
    'privacy.not.sell': 'Ich verkaufe deine Daten nicht.',
    'privacy.not.track': 'Ich tracke dich nicht quer durchs Internet.',
    'privacy.not.spam': 'Ich schicke dir keine nervigen Newsletter mit "Nur noch 24h"-Angeboten.',
    
    'privacy.cookies.title': 'Cookies & Tracking',
    'privacy.cookies.text1': 'Ich liebe Cookies 🍪, aber auf ABCbrain.xyz gibt es nur die notwendigen technischen Cookies.',
    'privacy.cookies.text2': 'Kein Google Analytics, kein creepy Retargeting – ich will dich nicht verfolgen.',
    
    'privacy.rights.title': 'Deine Rechte',
    'privacy.rights.text': 'Falls du deine Daten gelöscht haben möchtest, melde dich einfach. Ich kann nichts aus OpenAI oder Stripe rausziehen, aber deine Supabase-Daten lösche ich gern mit einem Klick.',
    
    'privacy.legal.title': 'Rechtlicher Kram & letzte Worte',
    'privacy.legal.text': 'Falls du Datenschutz ganz genau nimmst, empfehle ich: Einfach keine geheimen Weltformeln oder Superheldenpläne auf der Seite eingeben.',
    
    'privacy.contact.text': 'Fragen? Datenschutzbedenken? Einfach melden!',

    // Imprint Page
    'imprint.title': 'Impressum',
    'imprint.subtitle': 'Verantwortlich für diesen kreativen Wahnsinn',
    'imprint.contact.title': 'Kontaktinformationen',
    'imprint.contact.name': 'Patrick Hablützel',
    'imprint.contact.location': 'Geheimer Think Tank, irgendwo in der Schweiz 🏔️',
    'imprint.contact.phone': 'Noch nicht mit KI-Support ausgestattet',
    'imprint.about.title': 'Über ABCbrain.xyz',
    'imprint.about.intro': 'Dein smarter Begleiter zur Ideenfindung! 🚀',
    'imprint.about.description': 'Mit automatisch scrollenden Buchstaben bringen wir dein Brainstorming auf ein neues Level. Perfekt für Geistesblitze, spontane Genialität und kreative Eskalationen!',
    'imprint.ai.title': 'KI-Power von OpenAI',
    'imprint.ai.points': {
      'generation': 'Die smarte Zusammenfassung deiner Ideen wird von künstlicher Intelligenz von OpenAI generiert.',
      'disclaimer': 'Wenn die KI manchmal Unsinn redet – nun ja, auch Maschinen haben kreative Tage. 🤖💡',
      'liability': 'Keine Haftung für plötzliche Geistesblitze, geniale Geschäftsideen oder spontane Erleuchtungen.'
    },
    'imprint.privacy.title': 'Datenschutz? Klar!',
    'imprint.privacy.points': {
      'ownership': 'Deine Ideen gehören dir. Ich speichere nichts, was nicht gespeichert werden muss (es sei denn, die KI führt heimlich Tagebuch).',
      'openai': 'Die Kommunikation mit OpenAI läuft über deren API – ich habe keinen Zugriff auf deren interne Gedankengänge.'
    },
    'imprint.legal.title': 'Wichtiger rechtlicher Kram',
    'imprint.legal.points': {
      'hobby': 'ABCbrain.xyz ist ein Hobbyprojekt',
      'success': 'Falls ABCbrain dir hilft, der nächste Steve Jobs zu werden – denk beim Aufbau deines Imperiums an mich!'
    },

    // Export
    'export.title': 'ABC-Brainstorming',
    'export.exported_at': 'Exportiert am',
    'export.entries': 'Einträge',
    'export.letter': 'Buchstabe',
    'export.ai_analysis': 'KI-Analyse',
    'export.success': 'Exportiert!',
    'export.download': 'Liste herunterladen',

    // Letter Grid
    'letter_grid.input.placeholder': 'Gib einen Begriff ein...',
    'letter_grid.letter': 'Buchstabe',
    'letter_grid.entry.by': 'von',
    'letter_grid.entry.you': 'dir',
    'letter_grid.participant.former': 'ehemaligem Teilnehmer',
    'letter_grid.error.duplicate': 'Dieser Begriff wurde bereits eingegeben',
    'letter_grid.error.save_failed': 'Eintrag konnte nicht gespeichert werden. Bitte versuche es erneut.',

    // Scrolling Alphabet
    'scrolling_alphabet.pause': 'Pausieren',
    'scrolling_alphabet.resume': 'Fortsetzen',

    // Share Button
    'share.result.copy': 'Ergebnis-Link kopieren',
    'share.result.copied': 'Ergebnis-Link kopiert!',
    'share.result.aria': 'Ergebnis-Link kopieren',
    'share.resume.copy': 'Link zum Fortsetzen',
    'share.resume.copied': 'Link zum Fortsetzen kopiert!',
    'share.resume.aria': 'Link zum Fortsetzen',
    'share.error.create': 'Fehler beim Erstellen des Links',
    'share.error.copy': 'Link konnte nicht kopiert werden',

    // Summary Modal
    'summary.title': 'KI-Analyse deiner Ideen',
    'summary.loading': 'Analysiere deine Ideen...',
    'summary.error.title': 'Es gab einen Fehler bei der Analyse',
    'summary.error.retry': 'Schließen und erneut versuchen',
    'summary.payment.description': 'Um die KI-Analyse deiner Ideen zu erhalten, fahre mit der Zahlung fort. Der Betrag von 1 CHF wird sicher über Stripe abgewickelt.',
    'summary.payment.button': 'Zur sicheren Bezahlung',
    'summary.disclaimer': 'Diese Analyse wurde von einer KI erstellt und dient als Inspiration. Die endgültige Bewertung und Auswahl der Ideen liegt bei dir.',
    'summary.refresh': 'Neue Analyse'
  }
};